import React from 'react';

import { SvgIcon } from '@material-ui/core';

const FileDownloadOff = ({ classes, ...props }) => {
  return (
    <SvgIcon classes={classes} {...props}>
      <rect fill="none" height="24" width="24" />
      <path d="M9,6.17V3h6v6h4l-3.59,3.59L9,6.17z M21.19,21.19L2.81,2.81L1.39,4.22L6.17,9H5l7,7l0.59-0.59L15.17,18H5v2h12.17l2.61,2.61 L21.19,21.19z" />
    </SvgIcon>
  );
};

export default FileDownloadOff;
